import {memo} from 'react'
import {css} from '@emotion/react'
import {useTreeDocContext} from '@/components/TreeDoc/index.mjs'

const cssNode = css({
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
})

const cssNodeHidden = css({
    opacity: .5
})

const Node = ({node, ...props}) => {
    const map = useTreeDocContext()
    const background = map.useNodeBackground(node)
    const csss = [cssNode]

    if (node.isHidden) {
        csss.push(cssNodeHidden)
    }

    const style = {
        backgroundImage: `url('${background}')`,
    }

    return (
        <div
            css={csss}
            style={style}
            {...props}
        >
            <map.components.NodeContent node={node} />
        </div>
    )
}

const MemorizedNode = memo(Node, () => true)
MemorizedNode.displayName = 'Node'

export default MemorizedNode
